import { ExternalDocument } from 'lavva.webbluetooth';
import { TariffHoursRange } from '../../../types/tariffs';
import { HoursRangeFront } from '../../channel-details/optimizer/configuration/types';

export type DashboardPrice = {
  startingHour: number;
  color?: string | null;
};

export type EcoParams = {
  iconColor: string;
  text: string;
  icon: EcoBoxIcon;
};

export type TariffAdditionalData = {
  wholeWeekendCheaper: boolean;
  wholeHolidaysCheaper: boolean;
  ignoreSummerTimeChanges: boolean;
  hoursRanges: HoursRangeFront[];
};

export enum EcoBoxIcon {
  Leaf,
  Face,
}

export type DialogInstructionsData = {
  deviceName: string;
  documents: ExternalDocument[];
};

export type GetPricingTierParams = {
  hoursRanges: TariffHoursRange[];
  wholeWeekendCheaper: boolean;
  wholeHolidaysCheaper: boolean;
  hour: number;
};
